import {
  WSElement,
  WSLoader,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { Tabs } from "../../../components/Tabs";
import { queriesInternalAccounts } from "@query";
import { useQueryPaymentsStatus } from "../../../query/payments/queries";
import { RouteDashboard } from "../routes/RouteDashboard";
import { RouteTransactions } from "../routes/RouteTransactions";
import { selectorDefaultInternalAccount } from "../selectors/selectorDefaultInternalAccount";
import { RouteNewDashboard } from "./RouteNewDashboard";
import { FilterableTableInternalAccountTransactions } from "../components/TableInternalAccountTransactions/FilterableTableInternalAccountTransactions";
import { WalletGettingStarted } from "./WalletGettingStarted";

export const RouteRootDashboard = () => {
  const history = useHistory();
  const queryInternalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();
  const queryPaymentSettings = useQueryPaymentsStatus();

  const defaultInternalAccount = useMemo(
    () =>
      selectorDefaultInternalAccount(
        queryInternalAccounts.data?.data || [],
        queryPaymentSettings.data
      ),
    [queryInternalAccounts.data, queryPaymentSettings.data]
  );

  if (queryInternalAccounts.isInitialLoading) {
    return (
      <WSPage>
        <WSPageToolbar title="Wingspan Wallet" mb="2XL" />
        <WSLoader.Spinner />
      </WSPage>
    );
  }

  if (!defaultInternalAccount) {
    return <WalletGettingStarted />;
  }

  if (defaultInternalAccount.type === "ApPrefunding") {
    return (
      <WSPage>
        <WSPageToolbar title="Wingspan Wallet" />

        <Tabs
          mb="2XL"
          tabs={[
            {
              label: "Overview",
              path: "/member/wallet"
            },
            {
              label: "Transactions",
              path: "/member/wallet/transactions"
            }
          ]}
        />

        <Switch>
          <Route
            path="/member/wallet/transactions"
            render={() => (
              <FilterableTableInternalAccountTransactions
                internalAccountId={defaultInternalAccount.id}
              />
            )}
          />

          <Route
            path="/member/wallet"
            render={() => (
              <RouteNewDashboard
                internalAccountId={defaultInternalAccount.id}
              />
            )}
          />
        </Switch>
      </WSPage>
    );
  }

  return (
    <WSPage>
      <WSPageToolbar
        title="Wingspan Wallet"
        actions={[
          {
            buttonKind: "Primary",
            label: "Transfer",
            onClick: () => {
              history.push("/member/transfer?balance=wallet");
            }
          }
        ]}
      />

      <WSElement mb="2XL">
        <Tabs
          tabs={[
            {
              label: "Overview",
              path: "/member/wallet"
            },
            {
              label: "Transactions",
              path: "/member/wallet/transactions"
            }
          ]}
        />
      </WSElement>

      <Switch>
        <Route
          path="/member/wallet/transactions"
          component={RouteTransactions}
        />

        <Route path="/member/wallet" component={RouteDashboard} />
      </Switch>
    </WSPage>
  );
};
